class Current {
  get cityId () {
    return document.body.dataset.currentCityId
  }

  static get instance () {
    if (!this._instance) {
      this._instance = new Current()
    }

    return this._instance
  }
}

export default Current.instance
